import CheckOutlined from '@ant-design/icons/CheckOutlined';
import CloseOutlined from '@ant-design/icons/CloseOutlined';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

function PricingFeatureRow({ item, included = true }) {
  const Icon = included ? CheckOutlined : CloseOutlined;

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: 'flex-start' }}>
      <Icon
        style={{
          fontSize: '0.875rem',
          marginTop: 4,
          color: included ? 'var(--mui-palette-success-main)' : 'var(--mui-palette-error-main)'
        }}
      />
      <Typography variant="body2" color="text.secondary">
        {item}
      </Typography>
    </Stack>
  );
}

export default function PricingFeatureList({ title, items = [], included = true }) {
  if (!items.length) {
    return null;
  }

  return (
    <Stack spacing={0.75}>
      <Typography variant="subtitle2">{title}</Typography>
      {items.map((item) => (
        <PricingFeatureRow key={item} item={item} included={included} />
      ))}
    </Stack>
  );
}
